import ShimmerText from "@lib/common/components/ShimmerText/ShimmerText";
import { Group, Loader } from "@mantine/core";

export default function ThinkingIndicator() {
  return (
    <Group gap="xs">
      <Loader color="gray" size="1rem" />
      <ShimmerText size="sm" fw={500}>
        Thinking
      </ShimmerText>
    </Group>
  );
}
